import { render, staticRenderFns } from "./CalendarGrid.vue?vue&type=template&id=2df1883a&scoped=true&"
import script from "./CalendarGrid.vue?vue&type=script&lang=ts&"
export * from "./CalendarGrid.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarGrid.vue?vue&type=style&index=0&id=2df1883a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df1883a",
  null
  
)

export default component.exports